module.exports = __webpack_public_path__ + "static/media/b2bLogo.d58f90d3.png";